import { Fragment } from 'react';
import { Box, Typography, Divider } from '@mui/material';

// Use unified date utils
import { moment } from '../../../utils/dateUtils';

import { stringifyAddress } from '../../../utils/formatter';

const TooltipTitle = ({ info }) => (
  <Box>
    <Typography variant="body2">
      Status: <strong>{info.status}</strong>
    </Typography>

    {info.user && (
      <Typography variant="body2">
        Assigned to: <strong>{info.user ? info.user.fullName : 'Not assigned'}</strong>
      </Typography>
    )}

    {info.property && <Typography variant="body2">
      Address: <strong>{stringifyAddress(info.property)}</strong>
    </Typography>}

    {/* Preferred Technician - always show when available */}
    {info.preferredUser && (
      <Fragment>
        <Divider sx={{ my: 1, borderColor: 'rgba(255,255,255,0.3)' }} />
        <Typography variant="body2" sx={{ color: '#ef9a9a', fontWeight: 'bold' }}>
          👤 Preferred Technician:
        </Typography>
        <Typography variant="body2">
          <strong>{info.preferredUser.fullName || `${info.preferredUser.firstName} ${info.preferredUser.lastName}`}</strong>
          {info.user && info.preferredUser.id !== info.user.id && (
            <Typography component="span" sx={{ color: '#ffcdd2', ml: 1 }}>
              ⚠️ MISMATCH
            </Typography>
          )}
        </Typography>
      </Fragment>
    )}

    {/* Preferred Date/Time - always show when available */}
    {(info.preferredDate || info.preferredStartTime || info.preferredEndTime) && (
      <Fragment>
        <Divider sx={{ my: 1, borderColor: 'rgba(255,255,255,0.3)' }} />
        <Typography variant="body2" sx={{ color: '#90caf9', fontWeight: 'bold' }}>
          📅 Preferred Time:
        </Typography>
        {info.preferredDate && (
          <Typography variant="body2">
            Date: <strong>{moment(info.preferredDate).format('LL')}</strong>
          </Typography>
        )}
        {(info.preferredStartTime || info.preferredEndTime) && (
          <Typography variant="body2">
            Time:{' '}
            <strong>
              {info.preferredStartTime ? moment(info.preferredStartTime).format('h:mm') : '?'} - {info.preferredEndTime ? moment(info.preferredEndTime).format('h:mm A') : '?'}
            </strong>
          </Typography>
        )}
      </Fragment>
    )}

    <Typography variant="body2">Notes:</Typography>
    {info.notes && (
      <Fragment>
        {info.notes.map((note) => (
          <Typography variant="body2" key={note.id}>
            {note.note} {note.createdBy && <i>({note.createdBy.fullName || 'Unknown'})</i>}
          </Typography>
        ))}
      </Fragment>
    )}

    {info.reasons?.length > 0 && (
      <Fragment>
        <Typography variant="body2">Cancel Reason:</Typography>
        {info?.reasons.map((note) => (
          <Typography variant="body2" key={note.id}>
            {note.note} {note.createdBy && <i>({note.createdBy.fullName || 'Unknown'})</i>}
          </Typography>
        ))}
      </Fragment>
    )}
  </Box>
);

export default TooltipTitle;

